import * as firebase from 'firebase'
import { Store } from 'vuex';
import gsap from "gsap";

export default {
  state: {
    FXAudio:"gameAudio",
    isUnavailable:false,
    volume:1.0,
    fxVolume:.3,
    exhibitLayout:{},
    version:"1.2.05",
    isTester:false,
    gamePage:null,
    docAction:null,
    help:{state:"off",text:"HELP",from:null},
    helpList:[],
    showHelpIcon:true,
    shownHelps:[],
    helps:{},
    helpIndex:0,
    transition:{state:"off",text:"Meanwhile"},
    transitionCallBack:null,
    exhibitMode:"preview",
    firstPlay:true,
    showIntro:true,
    pages:["Wrecks","Experts","Documents","Location","Depthmap","Budget","Dossier","Exhibit"]
  },
  mutations: {
    setIsTester(state,payload){
      state.isTester=payload
    },
    setIsUnavailable(state,payload){
      state.isUnavailable=payload
    },
    setFirstPlay(state,payload){
      state.firstPlay=payload
    },
    setShowIntro(state,payload){
      state.showIntro=payload
    },
    setVolume(state,payload){
      state.volume=payload
    },
    setFXVolume(state,payload){
      state.fxVolume=payload
    },
    setDocAction(state,payload){
      state.docAction=payload
    },
    addHelp(state,payload){
      state.helps[payload.id]=payload
    },
    setHelpList(state,payload){
      state.helpList=payload
    },
    setShowHelpIcon(state,payload){
      state.showHelpIcon=payload
    },
    setHelpIndex(state,payload){
      state.helpIndex=payload
    },
    setExhibitLayout(state,payload){
      console.log("LAYOUT SET",payload)
      state.exhibitLayout=payload
    },
    setTransition(state,payload){
      state.transition=payload
    },
    setHelp(state,payload){
      if(payload && payload.playOnce){
        state.shownHelps.push(payload.id)
      }
      
     
      state.help=payload
    },
    setGamePage(state, payload) {
        state.gamePage = payload
    },
    setExhibitMode(state,payload){
      state.exhibitMode=payload
    }
  },
  actions: {
    
    nextHelp({commit,state},payload){
     
      let helpFound=false
      let nextHelpIndex=(state.helpIndex+1)%state.helpList.length
      console.log("next help",nextHelpIndex)
      let item
      let loopCount=0
      while(!helpFound  && loopCount<50){
        loopCount++
        item=state.helpList[nextHelpIndex]
        
        if(!state.shownHelps.includes(item)){
          for(var h in state.helps){
            if(!helpFound){
           // console.log(state.helps[h])
            if(h==item && state.helps[h].type!="event"){
              helpFound=true
              console.log("help found",nextHelpIndex)
              commit('setHelpIndex',nextHelpIndex)
            }else{
              console.log("no next help",nextHelpIndex)
            }
          }
          }
         if(!helpFound){
          nextHelpIndex=(nextHelpIndex+1)%state.helpList.length
          
         }
          
        }else{
        
          nextHelpIndex=(nextHelpIndex+1)%state.helpList.length
          
        }
      }

    },
    stopHelp({commit}){
     
      commit('setHelp',null)
    },
    showBasicHelp({commit,state},payload){
      if(payload.delay){
        gsap.delayedCall(payload.delay,function(){
          commit('setHelp',{state:"helpIn",text:payload.text,callBack:payload.callBack})
        })
      }else{
        if(payload.text){
          commit('setHelp',{state:"helpIn",text:payload.text,callBack:payload.callBack})
        }else{
          commit('setHelp',{state:"helpIn",text:payload})
        }
        
      }
     
    },
    showHelp({commit,state},payload){
      if(!state.help || state.help.state=="off" ){
        for(var h in state.helps){
          if(h==payload.id){
            state.helps[h].state="helpIn"
            commit('setHelp',state.helps[h])
          }
        }
      }else{
        console.error("Help Not Ready",state.help)
      }
    },
    showNextHelp({commit,state},payload,){
      console.log("payload",payload)
      payload.shown=true
      if(!state.help || state.help.state=="off" || payload.force=="force"){
        payload.state="helpIn"
        payload.force=null
        commit('setHelp',payload)
      }else{
        console.error("Next Help Not Ready",state.help)
      }
    },
    startTransition({commit,state},payload){
      if(!state.transition || state.transition.state=="off" ){
        payload.state="transIn"
        commit('setTransition',payload)
      }else{
        console.error("Transition Not Ready",state.transition)
      }
    }
  },
  getters: {
    getIsUnavailable(state,getters){
      return state.isUnavailable && !getters.getIsTester
    },
    getShowIntro(state){
      return state.showIntro
    },
    getFirstPlay(state){
      return state.firstPlay
    },
    getDocAction(state){
      return state.docAction
    },
      getHelps(state){
        return state.helps
      },
      getShownHelps(state){
        return state.shownHelps
      },
      getNextHelp(state){
        let helpId=state.helpList[state.helpIndex]
        for(var h in state.helps){
          if(h==helpId){
            return state.helps[h]
          }
        }
        //return state.helps
      },
      getVersion(state){
        return state.version
      },
      getIsTester(state){
          return state.isTester
      },
      getPages(state){
        return state.pages
      },
      getGamePage(state) {
        return state.gamePage
      },
      getTransition(state){
        return state.transition
      },
      getHelp(state){
        return state.help
      },
      getExhibitMode(state){
        return state.exhibitMode
      },
      getExhibitLayout(state,getters){
        console.log("GET EXHIBIT",getters.user,getters.getActiveWreck,state.exhibitLayout)
        if(getters.user && getters.getActiveWreck){
          return state.exhibitLayout
        }else{
          return null
        }
       
      },
      getPublicExhibitLayout(state,getters){
        console.log("GET EXHIBIT",getters.user,getters.getActiveWreck,state.exhibitLayout)
       if(state.exhibitLayout){
        return state.exhibitLayout
       }else{
        return null
      }
          
        
       
      },
      getVolume(state){
        return state.volume;
      },
      getFXVolume(state){
        return state.fxVolume;
      },
      getFXAudio(state){
        return state.FXAudio
      },
      getShowHelpIcon(state){
        return state.showHelpIcon
      },
     
  }
}

